import { ActionPanelViews, DocumentViews } from "@store/doc-viewer/doc-viewer.state";

export const DocumentViewToActionPanelSyncMap: Map<DocumentViews,ActionPanelViews> = new Map<DocumentViews,ActionPanelViews>([
    ['text-compare','compare-doc']
]);